import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const WarningIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M13.06 18.32c0 .58-.48 1.08-1.06 1.08-.58 0-1.06-.5-1.06-1.08 0-.58.5-1.06 1.06-1.06s1.06.5 1.06 1.06Zm-.25-9.45v7.22h-1.6V8.87h1.6Z M12 4.08 21.31 21H2.69L12 4.08ZM12 2 1 22h22L12 2Z" />
  </IconWrapper>
)

export default WarningIconMedium
